<template>
  <div class="layout">
    <router-view class="page" />

    <van-tabbar route active-color="#FF6900">
      <van-tabbar-item v-if="userStore.showHomePage" to="/home">
        <template #icon="{ active }">
          <img
            v-if="active"
            src="@/assets/gc-bi/icon/SVG/home-active.svg"
            alt="home"
            style="width: 24px; height: 24px"
          />
          <img
            v-else
            src="@/assets/gc-bi/icon/SVG/home.svg"
            alt="home"
            style="width: 24px; height: 24px"
          />
        </template>
        Homepage
      </van-tabbar-item>
      <van-tabbar-item to="/approvals" icon="completed-o"> Approvals </van-tabbar-item>
      <van-tabbar-item v-if="userStore.showDoorSummary" to="/history" icon="underway-o"> Door Summary </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()

onMounted(() => {
  void userStore.loadUser()
})
</script>
<style scoped>
.layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.page {
  flex: 1;
  overflow-y: auto;
}
@media (orientation: landscape) {
  .layout {
    zoom: 0.7;
  }
}
</style>
